/**
 * Tire une formulation aléatoire parmi plusieurs variantes équivalentes,
 * pour éviter des réponses de succès trop mécaniques/déterministes
 */
export function pickVariant(templates: string[]): string {
  return templates[Math.floor(Math.random() * templates.length)];
}
